import { ReactNode } from 'react';

import Sidebar from '@/components/Sidebar/Sidebar';

import MiddlewareRoute from './MiddlewareRoute/MiddlewareRoute';

export const ProtectedRoute = ({
  children,
  hideSidebar,
}: {
  children: ReactNode;
  hideSidebar?: boolean;
}) => {
  if (hideSidebar) {
    return (
      <MiddlewareRoute>
        <div className="p-10 w-full h-screen overflow-y-auto">{children}</div>
      </MiddlewareRoute>
    );
  }

  return (
    <MiddlewareRoute>
      <Sidebar>
        <div className="p-10 w-full h-screen overflow-y-auto">{children}</div>
      </Sidebar>
    </MiddlewareRoute>
  );
};

export default ProtectedRoute;
